import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { Box, Tooltip, IconButton, Typography } from '@mui/material'
export const OrderSummary = ({ orders = [] }) => {
  return (
    <>
      {orders.map(
        ({ companyAccountId, htg_company, amount, hasSufficientPoints, companyName, salesId }) => (
          <Box
            key={htg_company}
            display={'flex'}
            alignItems={'center'}
            color={hasSufficientPoints ? 'green' : 'red'}
            minWidth={150}
          >
            {htg_company}: {amount}
            <Tooltip
              enterTouchDelay={0}
              title={
                <Box>
                  <Typography>
                    <b>Company Id:</b> {companyAccountId} ({htg_company})
                  </Typography>
                  <Typography>
                    <b>Company Name:</b> {companyName}
                  </Typography>
                  <Typography>
                    <b>Sales ID:</b> {salesId}
                  </Typography>
                  <Typography>
                    <b>Amount:</b> {amount}
                  </Typography>
                </Box>
              }
            >
              <IconButton size='small' style={{ marginLeft: '5px' }}>
                <InfoIcon fontSize='small' color='primary' sx={{ fontSize: '18px' }} />
              </IconButton>
            </Tooltip>
          </Box>
        )
      )}
    </>
  )
}
